/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Ent_Feat1Inputs */

const en_mk_price_ent_feat1 = /** @type {(inputs: Mk_Price_Ent_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-hosting or on-shore Indonesian hosting`)
};

const id_mk_price_ent_feat1 = /** @type {(inputs: Mk_Price_Ent_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-host atau hosting on-shore Indonesia`)
};

/**
* | output |
* | --- |
* | "Self-hosting or on-shore Indonesian hosting" |
*
* @param {Mk_Price_Ent_Feat1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_ent_feat1 = /** @type {((inputs?: Mk_Price_Ent_Feat1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Ent_Feat1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_ent_feat1(inputs)
	return en_mk_price_ent_feat1(inputs)
});